import React from 'react';
import PersonalizeVideo from '../../../Assets/images/Spectra/EfficientDocumentation/edit-personalize.webm';
import PersonalizeVideoMp from '../../../Assets/images/Spectra/EfficientDocumentation/edit-personalize.mp4';

const EditPersonalize = () => {
    return (
        <div className='aug-efficient-documentation__item'>
            <div className="row align-items-center">
                <div className='col-md-12 col-lg-6'>
                    <div className='aug-efficient-documentation__content'>
                        <h6 className='mb-2'>STEP 3</h6>
                        <h3 className='mb-3'>Edit & Personalize</h3>
                        <p className='mb-0'>Use voice commands to navigate and make corrections or enhancements to your clinical document. Also use inbuilt features like Macros, Templates, Custom Vocabularies, Formatting Preferences, and more, to create a distinct workflow.</p>
                    </div>
                </div>
                <div className='offset-md-1 col-12 col-md-10 col-lg-5'>
                    <div className='aug-efficient-documentation__video'>
                        <div className="">
                            <video width="100%" id='videoPersonalize' playsInline muted autoPlay="autoPlay" loading="lazy" loop="loop">
                                <source src={PersonalizeVideo} type="video/webm" />
                                <source src={PersonalizeVideoMp} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditPersonalize;